import '../styles/Home.css';

import React, { useEffect } from "react";
import { useQuery } from '@tanstack/react-query';
import { setBackgroundImage } from "../helpers/helpers";

import Loader from "../components/Loader";
import MediaList from "../components/MediaList";

const fetchTrendingMovies = async () => {
    const apiKey = process.env.REACT_APP_TMDB_API_KEY;
    const response = await fetch(`https://api.themoviedb.org/3/trending/movie/week?language=en-GB`, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${apiKey}`,
        }
    });
    
    return await response.json();
}

const fetchTrendingTv = async () => {
    const apiKey = process.env.REACT_APP_TMDB_API_KEY;
    const response = await fetch(`https://api.themoviedb.org/3/trending/tv/week?language=en-GB`, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${apiKey}`,
        }
    });
    
    return await response.json();
}

const Home = () => {
    useEffect(() => {
        setBackgroundImage('');
        document.title = 'The Movie Tracker';
    }, []);

    const { data: trendingMovies, isLoading: isLoadingMovie, error: errorMovie } = useQuery({
        queryKey: ['trendingMovies'],
        queryFn: fetchTrendingMovies,
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });

    const { data: trendingTv, isLoading: isLoadingTv, error: errorTv } = useQuery({
        queryKey: ['trendingTv'],
        queryFn: fetchTrendingTv,
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });

    if (isLoadingMovie || isLoadingTv) return <Loader fullscreen message="Loading..." />;
    if (errorMovie) return <div>Error loading trending movies.</div>;
    if (errorTv) return <div>Error loading trending TV shows.</div>;

    return (
        <div className="home">
            <h1 className="home-title">Trending Movies</h1>
            <MediaList media={trendingMovies.results} row={true} />

            <h1 className="home-title">Trending TV Shows</h1>
            <MediaList media={trendingTv.results} row={true} />
        </div>
    );
}

export default Home;